/**
 * Calcula o pagamento periódico (equivalente à função PGTO do Excel) Origem CHATGPT
 * Giovani 09/01/2026
 * @param {number} taxa - Taxa de juros por período (ex: 0.01)
 * @param {number} nper - Número total de períodos
 * @param {number} vp   - Valor presente (normalmente positivo)
 * @param {number} vf   - Valor futuro (opcional, padrão = 0)
 * @param {number} tipo - 0 = pagamento no fim | 1 = pagamento no início
 *
 * @returns {number} Valor da parcela (normalmente negativo)
 */
export function PGTO(taxa, nper, vp, vf = 0, tipo = 0) {
  if (taxa === 0) {
    return -(vp + vf) / nper;
  }

  const fator = Math.pow(1 + taxa, nper);

  return -(((vp * fator + vf) * taxa) / ((1 + taxa * tipo) * (fator - 1)));
}
